import { FunctionalComponent, h } from '@stencil/core';

type SlideProps = {
  key?: string;
  cover: string;
}

export const Slide: FunctionalComponent<SlideProps> = ({ key, cover }, children) => (
  <div key={key} class="slide absolute inset--0">
    <div class="slide-inner absolute inset--0">
      <loadable-image
        classes="
          cover
          absolute
          inset--0
          w--100
          h--100
          animation--fade-in
          duration--120
        "
        src={cover}
      />
      <div
        class="
          absolute
          inset--0
          col
          align--center-v
          p--m
        "
      >{children}</div>
    </div>
  </div>
);
